import { Button, Chip, Divider, Stack, Typography } from "@mui/material";
import { useRef, useState } from "react";
import { APP_ICONS } from "../../assets";
import AppContainer from "../../components/containers/AppContainer";
import EditVendorDialog from "../../components/dialog/EditVendorDialog";
import SuspendDialog from "../../components/dialog/SuspendDialog";
import Loader from "../../components/loader";
import { updateVendorProfile } from "../../services/Profile";
import { getVendorDetails } from "../../services/Vendor";
import { constants } from "../../theme/Variables";

const RenderUsersData = ({ field, value }) => {
  return (
    <Stack direction={"row"} alignItems={"center"} gap={0.5} flexWrap={"wrap"}>
      <Typography variant="body1" fontWeight={500}>
        {field}:{" "}
      </Typography>
      <Typography color={"customColor.scorpion"}>{value}</Typography>
    </Stack>
  );
};

const returnStatusColor = (status) => {
  if (status === "Active")
    return {
      color: "customColor.malachite",
      bgColor: "customColor.blueRomance",
    };
  if (status === "InActive")
    return {
      color: "customColor.gray",
      bgColor: "customColor.alto",
    };
};

const VendorProfile = ({ vendorDetails, setVendorProfileData, state }) => {
  const [isLoading, setIsLoading] = useState(false);
  const openSuspendDialog = useRef();
  const openEditDialog = useRef();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    bbShare: 0,
    vendorShare: 0,
    customerShare: 0,
    vendorReferedShare: 0,
  });
  const handleOpenSnackBar = (type, message) => {
    constants.snackRef.isOpenSnack({
      snackType: type,
      snackMessage: message,
    });
  };
  const fetchVendorsDetails = async () => {
    try {
      setIsLoading(true);
      const response = await getVendorDetails(state?._id);
      setIsLoading(false);
      let data = response?.data?.data || null;
      setVendorProfileData(data);
    } catch (error) {
      setIsLoading(false);
      console.log(error, "errorerrorerrorerror");
    }
  };
  const handleSuspendVendor = async () => {
    try {
      let payload = {
        status: "InActive",
      };
      setIsLoading(true);
      const response = await updateVendorProfile(vendorDetails?._id, payload);
      setIsLoading(false);
      if (response.status == 200 || response.status == 201) {
        handleOpenSnackBar("success", response?.data?.message);
        openSuspendDialog.current.closeDialog();
        fetchVendorsDetails();
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      console.log(error, "errorerrorerrorerror");
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdateProfile = async () => {
    try {
      if (!formData.name) {
        handleOpenSnackBar("error", "Vendor name is required.");
      } else if (!formData.phoneNumber) {
        handleOpenSnackBar("error", "Phone number is required.");
      } else if (!formData.vendorShare && state?.role != "user") {
        handleOpenSnackBar("error", "Vendor share is required.");
      } else if (!formData.bbShare && state?.role != "user") {
        handleOpenSnackBar("error", "BB share is required.");
      } else if (
        parseFloat(formData.vendorShare) +
          parseFloat(formData.customerShare) +
          parseFloat(formData.vendorReferedShare) +
          parseFloat(formData.bbShare) !==
          100 &&
        state?.role != "user"
      ) {
        handleOpenSnackBar(
          "error",
          "Vendor Share, Customer Share and BB Share must sum up to 100."
        );
      } else {
        let payload = {
          name: formData.name,
          email: formData.email,
          phoneNumber: formData?.phoneNumber,
          bbShare: Number(formData?.bbShare),
          vendorShare: Number(formData?.vendorShare),
          customerShare: Number(formData?.customerShare),
          vendorReferedShare: Number(formData?.vendorReferedShare),
        };
        setIsLoading(true);
        const response = await updateVendorProfile(vendorDetails?._id, payload);
        setIsLoading(false);
        if (response.status == 200 || response.status == 201) {
          handleOpenSnackBar("success", response?.data?.message);
          openEditDialog.current.closeDialog();
          fetchVendorsDetails();
        } else {
          handleOpenSnackBar("error", response?.data?.message);
        }
      }
    } catch (error) {
      console.log(error, "errorerrorerrorerror");
      setIsLoading(false);
    }
  };

  return (
    <>
      <Loader isloading={isLoading} />
      <AppContainer
        styleProps={{
          p: 2,
          borderRadius: "6px",
        }}
      >
        <Stack alignItems={"center"} gap={1} mb={5}>
          <Typography fontSize={"1.375rem"} fontWeight={500}>
            {vendorDetails?.name}
          </Typography>
          <Chip
            label={vendorDetails?.status}
            sx={{
              borderRadius: "8px",
              backgroundColor: returnStatusColor(vendorDetails?.status)
                ?.bgColor,
              color: returnStatusColor(vendorDetails?.status)?.color,
            }}
          />
        </Stack>

        <Typography fontSize={"1.125rem"} fontWeight={500}>
          Detail
        </Typography>
        <Divider />
        <Stack mt={1} gap={0.6}>
          <RenderUsersData field={"Username"} value={vendorDetails?.name} />
          <RenderUsersData field={"Email"} value={vendorDetails?.email} />
          <RenderUsersData field={"Status"} value={vendorDetails?.status} />
          <RenderUsersData
            field={"Contact"}
            value={vendorDetails?.phoneNumber}
          />
        </Stack>

        <Stack direction={{ md: "row" }} gap={1} mt={3}>
          <Button
            variant="custom_outlined"
            endIcon={<img src={APP_ICONS.editIconBlue} width={22} />}
            onClick={() => {
              openEditDialog.current.openDialog(vendorDetails);
            }}
          >
            Edit Details
          </Button>
          <Button
            variant="suspend_button"
            endIcon={<img src={APP_ICONS.warningIcon} width={22} />}
            onClick={() => {
              openSuspendDialog.current.openDialog({
                warningText: `Are You Sure You Want To Suspend This ${
                  state?.role != "user" ? "Vendor" : "User"
                }?`,
              });
            }}
          >
            Suspend User
          </Button>
        </Stack>
      </AppContainer>
      <SuspendDialog
        ref={openSuspendDialog}
        handleSuspend={handleSuspendVendor}
      />
      <EditVendorDialog
        ref={openEditDialog}
        handleInputChange={handleInputChange}
        handleUpdate={handleUpdateProfile}
        formData={formData}
        setFormData={setFormData}
      />
    </>
  );
};

export default VendorProfile;
